module.exports = "https://patron-cdn-prod.biblioboard.com/static/media/error403-portrait_d18fb9c.gif";